export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            投稿通道
          </h2>
          <p className="text-sm text-foreground-500">
            你有猛料？欢迎匿名投稿，每一条爆料我们都会认真对待
          </p>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex flex-col items-center text-center p-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">邮件投稿</h3>
              <p className="text-xs text-foreground-500">
                发送爆料内容至投稿邮箱，支持文字与截图附件，24 小时内审核反馈
              </p>
              <span className="mt-2 text-xs font-medium text-accent-600">
                tips@meiridagua.com
              </span>
            </div>

            <div className="flex flex-col items-center text-center p-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">微信投稿</h3>
              <p className="text-xs text-foreground-500">
                添加每日大瓜官方微信，直接发送爆料内容，随时随地快速投稿
              </p>
              <span className="mt-2 text-xs font-medium text-accent-600">
                meiridagua666
              </span>
            </div>

            <div className="flex flex-col items-center text-center p-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                <i className="ri-shield-user-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">匿名保障</h3>
              <p className="text-xs text-foreground-500">
                所有投稿均严格匿名处理，绝不泄露爆料人任何信息，让你安心分享每一颗瓜
              </p>
              <span className="mt-2 text-xs font-medium text-accent-600">
                隐私第一 · 绝不追踪
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}